import { CircleCrossIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Experience } from "types";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";
import { getSeller } from "@/utils/getSeller";

interface ProductAvailabilityAlertProps {
    experience: Experience;
}

export const ProductAvailabilityAlert = ({ experience }: ProductAvailabilityAlertProps) => {
    const history = useHistory();
    const seller = getSeller();
    const hasAvailableTimeslot = useCreatePurchaseStore((state) => state.hasAvailableTimeslot);
    const timeslot = useCreatePurchaseStore((state) => state.getActiveItem().timeslot);
    const showAlert = hasAvailableTimeslot === false && !timeslot;
    const isSellerOwnedExperience = experience.seller.id === seller.id;

    if (!showAlert) {
        return null;
    }

    const handleClick = () => history.push(`/products/experiences/${experience.id}/schedules`);

    return (
        <Alert color="danger">
            <div className="flex">
                <CircleCrossIcon size="large" className="flex-shrink-0 text-danger-darker" />
                <span className="ml-3">
                    {isSellerOwnedExperience ? (
                        <>
                            This product does not have any future availability. To make a purchase,&nbsp;
                            <span className="cursor-pointer underline" onClick={handleClick}>
                                please configure more availability
                            </span>
                            &nbsp; for the product.
                        </>
                    ) : (
                        "This product does not have any future availability."
                    )}
                </span>
            </div>
        </Alert>
    );
};
